import React from 'react';
import { Button, MenuItem, Stack, Typography } from '@mui/material';
import { CheckCircleOutlined as AssignedIcon, CropFree as AvailableIcon } from '@mui/icons-material';
import { EmulatorType, Subscription } from '@localstack/types';
import { Dropdown, DropdownProps, GridComponent } from '@localstack/ui';

import { LicenseAssignmentPlanLabel } from './LicenseAssignmentPlanLabel';
import { SeatAvailability } from './types';
import { computeTotalNumberOfSeats } from './utils';

export interface SubscriptionSeatsSummaryDropdownProps {
  subscriptionsByEmulator: Record<EmulatorType, Record<string, Subscription>>;
  subscriptionsSeatsAvailability: SeatAvailability;
}

export const SubscriptionSeatsSummaryDropdown = ({
  subscriptionsByEmulator,
  subscriptionsSeatsAvailability,
}: SubscriptionSeatsSummaryDropdownProps): JSX.Element => (
  <>
    {Object.entries(subscriptionsByEmulator).map(([emulator, subsMap]) => (
      <Dropdown
        key={emulator}
        size="small"
        menuListProps={{ disablePadding: true }}
        renderButton={({ onClick }: DropdownProps) => (
          <Button onClick={onClick} sx={{ minWidth: 'auto' }}>
            <LicenseAssignmentPlanLabel
              emulator={emulator as EmulatorType}
              title={computeTotalNumberOfSeats(subsMap).toString()}
            />
          </Button>
        )}
      >
        {Object.values(subsMap).map((sub, subIdx, subsArr) => (
          <React.Fragment key={sub.id}>
            <MenuItem
              disabled
              sx={{ opacity: '1 !important', display: 'block', borderRadius: '0 !important' }}
              divider={subIdx < subsArr.length - 1}
            >
              <Stack direction="column" spacing={0.5}>
                <GridComponent columns="min-content 1fr min-content" columnGap="4px" style={{ padding: 0 }}>
                  <LicenseAssignmentPlanLabel
                    emulator={emulator as EmulatorType}
                    family={sub.plan.family}
                    title="Total licenses"
                  />
                  <div />
                  <Typography variant="body1">{subscriptionsSeatsAvailability[sub.id]?.total}</Typography>
                </GridComponent>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                  <Stack direction="row" alignItems="center" spacing={0.5}>
                    <AssignedIcon
                      sx={{ color: 'text.disabled', height: (theme) => theme.spacing(2) }}
                      fontSize="small"
                    />
                    <Typography variant="caption" color="text.disabled">
                      Assigned
                    </Typography>
                  </Stack>
                  <Typography variant="caption" color="text.disabled">
                    {subscriptionsSeatsAvailability[sub.id]?.taken}
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                  <Stack direction="row" alignItems="center" spacing={0.5}>
                    <AvailableIcon
                      sx={{ color: 'text.disabled', height: (theme) => theme.spacing(2) }}
                      fontSize="small"
                    />
                    <Typography variant="caption" color="text.disabled">
                      Available
                    </Typography>
                  </Stack>
                  <Typography variant="caption" color="text.disabled">
                    {subscriptionsSeatsAvailability[sub.id]?.free}
                  </Typography>
                </Stack>
              </Stack>
            </MenuItem>
          </React.Fragment>
        ))}
      </Dropdown>
    ))}
  </>
);
